import { Trans } from '@lingui/macro'

import * as React from 'react'

import { Badge } from '~ui/components/badges/Badge'
import { FlexCentered } from '~ui/components/layout/Box'

type TProps = NoChildren & {
  /**
   * `margin` of the badge,
   * useful if you need to position the badge absolutely into another element
   */
  margin?: PropsOf<typeof FlexCentered>['margin']
}

/**
 * Rounded badge of the error color with the uppercase `sold out` translated label
 */
export const SoldOutBadge: React.FC<TProps> = ({ margin }) => {
  return (
    <Badge margin={margin} bgColor={`specialColors.error`}>
      <Trans>Sold out</Trans>
    </Badge>
  )
}
